import { styles } from '../../../../utilities'

export default () => {
  return {
    default: {
      wrap: {
        whiteSpace: 'pre-wrap',
      },
      count: {
        whiteSpace: 'pre-wrap',
      },
    },
    hidden: styles.visuallyHidden,
  } as const
}
